<!--
  same as TabItem but uses v-show instead of v-if what doesn't manipulate the DOM,
  so the 'states' in the tabs stay the same. this is used in e.g. the fileEdit popup,
  where values from both tabs can be selected and need to persist through tab switches.
-->
<template>
  <div class="tabs__content" v-show="selectedTitle === props.title">
    <slot />
  </div>
</template>

<script setup>
import { inject, defineProps  } from 'vue'
const props = defineProps({
  title: String
})
const selectedTitle = inject('selectedTitle')
</script>
